module.exports = __webpack_public_path__ + "static/media/saraPhoto.6450a78e.jpg";